export const OPEN_MISSED_CHECKOUT_EVENT = "open-missed-checkout";

export const openMissedCheckout = () => {
  window.dispatchEvent(new CustomEvent(OPEN_MISSED_CHECKOUT_EVENT));
};
